<div *transloco="let t; read: 'field-list-filters'" class="field-list-filter__container">
  <p class="field-list-filter__description">{{ t('filter-list-by') }}</p>
  <div class="field-list-filter__hor-line"></div>
  <div class="field-list-filter__dropdowns-container">
    @for (fd of filterOptions(); track fd.id) {
      <xi-dropdown
        [id]="fd.id"
        [label]="fd.label"
        [inMenuSearch]="true"
        [placeholder]="t('no-filters')"
        [data]="fd.data"
        [value]="fd.selected"
        select="multiSelectAll"
        (onValueChange)="onFilterChange($event.detail.selected, fd.id)"
      ></xi-dropdown>
    }
  </div>
  <div class="field-list-filter__hor-line"></div>
  <div class="field-list-filter__actions-container">
    <xi-default-button fill="text" [text]="t('cancel')" (onClick)="onCancel()"></xi-default-button>
    <div class="field-list-filter__actions-container-right">
      <xi-default-button
        fill="text"
        [text]="t('reset-all-filters')"
        [disabled]="!areFiltersApplied()"
        (onClick)="onResetAllFilters()"
      ></xi-default-button>
      <xi-default-button
        [text]="t('apply-filters')"
        [disabled]="projectFieldsLoading()"
        (onClick)="onApplyFilters()"
      ></xi-default-button>
    </div>
  </div>
</div>
